import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

import Button from 'components/field/Button';
import FormItem from 'components/form/FormItem';

import useAlert from 'hooks/useAlert';
import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { SALES_CHANNELS } from 'services/consts';

import AppLogger from 'utils/AppLogger';

import { faPlug } from '@fortawesome/pro-solid-svg-icons';

const TestConnectionButton = () => {
	const { salesChannel } = useSelector((state) => state.salesChannel);
	const { showError, showSuccess } = useAlert();
	const axiosPrivate = useAxiosPrivate();
	const {
		handleSubmit,
		formState: { isLoading, isSubmitting }
	} = useFormContext();

	const testConnection = useCallback(async (data) => {
		const req = Object.fromEntries(Object.entries(data).filter(([_, value]) => value !== null));
		try {
			const response = await axiosPrivate.post(SALES_CHANNELS.TEST_CONNECTION_SERVICE, {
				...(salesChannel.saleChannelID
					? {
							credentialsID: salesChannel.ID,
							salesChannelID: salesChannel.saleChannelID
						}
					: {
							salesChannelID: salesChannel.ID
						}),
				...req
			});

			if (response.data.status === true) {
				showSuccess({
					message: 'success.testCompletedSuccessfully'
				});
			} else if (response.data.status === false) {
				showError({
					message: response?.data?.code ?? 'error.testFailed'
				});
			} else {
				AppLogger.error(response);
				showError({
					message: response?.data?.code ?? 'error.testFailed'
				});
			}
		} catch (error) {
			AppLogger.error(error);
			showError({
				message: error?.response?.data?.code ?? 'error.testFailed'
			});
		}
	}, []);
	return (
		<FormItem>
			<Button
				icon={faPlug}
				loading={isLoading || isSubmitting}
				loadingLabel="testing"
				label="testConnection"
				onClick={handleSubmit(testConnection, AppLogger.log)}
				variant="outline"
				fullWidth
			/>
		</FormItem>
	);
};

export default TestConnectionButton;
